// == Import : npm
import { connect } from 'react-redux';

// == Import : local
import Media from '../../screen/Media';

// Action Creators

const mapStateToProps = (state, ownProps) => ({
  //datas: state.datas,
  waitingRequest: state.waitingRequest,
  connected: state.connected,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  /*Media: (mail, password) => {
    dispatch(Media(mail, password, ownProps.history));
  },*/
});

// Container
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Media);
